// Mock content for the ej-tech HK Startups financing-record page.

/**
 * `date` is the Chinese short form — "26年01月" is January 2026. The year
 * filter reads the two digits before 年, so the tab list and the rows cannot
 * disagree.
 */
export const FINANCING_ROWS: { date: string; name: string; amount: string }[] = [
  // 2026 — the year the site is currently in. The table had none, so the tab
  // QA asked for would have opened an empty page.
  { date: "26年02月", name: "Animoca Brands", amount: "$25M" },
  { date: "26年01月", name: "Prenetics", amount: "$18M" },
  { date: "26年01月", name: "GoGoX", amount: "$32M" },
  { date: "25年08月", name: "ApexPay", amount: "$4.5M" },
  { date: "25年08月", name: "Robocore Technology", amount: "$30M" },
  { date: "25年07月", name: "圓幣科技", amount: "$40M" },
  { date: "25年07月", name: "Bowtie", amount: "$70M" },
  { date: "25年05月", name: "PHASE Scientific", amount: "$34M" },
  { date: "25年03月", name: "RedotPay", amount: "$40M" },
  { date: "25年02月", name: "Klook", amount: "$100M" },
  { date: "24年12月", name: "KPay", amount: "$55M" },
  { date: "24年11月", name: "KPay", amount: "$10M" },
  { date: "24年11月", name: "The Z Label", amount: "$11.7M" },
  /*
    A longer record.

    Thirteen rows is not a "紀錄" and, at 20 per page, could never show that the
    table paginates at all — QA: "add more data" alongside "add pagination to
    the table, 20 items per page". Names and rounds follow the same shape as the
    rows above; replace wholesale when the real dataset lands.
  */
  { date: "24年10月", name: "Gense Technologies", amount: "$14M" },
  { date: "24年10月", name: "EMPAI", amount: "$26M" },
  { date: "24年09月", name: "Pantheon Lab", amount: "$8M" },
  { date: "24年09月", name: "Sanguine Diagnostics", amount: "$12.5M" },
  { date: "24年08月", name: "Fano Labs", amount: "$18M" },
  { date: "24年07月", name: "Neurogress HK", amount: "$9.2M" },
  { date: "24年06月", name: "Cardio Diagnostics Asia", amount: "$21M" },
  { date: "24年05月", name: "AutoX HK", amount: "$45M" },
  { date: "24年04月", name: "Lynk Global", amount: "$33M" },
  { date: "24年03月", name: "WeLab", amount: "$110M" },
  { date: "24年02月", name: "Airwallex HK", amount: "$85M" },
  { date: "24年01月", name: "Prenetics Health", amount: "$29M" },
  { date: "23年12月", name: "SmartMore", amount: "$52M" },
  { date: "23年11月", name: "Insilico Medicine", amount: "$95M" },
  { date: "23年10月", name: "Ampd Energy", amount: "$16M" },
  { date: "23年09月", name: "Zeek Logistics", amount: "$13M" },
  { date: "23年08月", name: "OneDegree", amount: "$28M" },
  { date: "23年07月", name: "Micro Connect", amount: "$58M" },
  { date: "23年06月", name: "Animoca HK", amount: "$76M" },
  { date: "23年05月", name: "PolyU Ventures", amount: "$11M" },
  { date: "23年04月", name: "Terminus HK", amount: "$24M" },
  { date: "23年03月", name: "Hex Trust", amount: "$88M" },
  { date: "23年02月", name: "Bowtie Life", amount: "$35M" },
  { date: "23年01月", name: "Grana", amount: "$7.5M" },
  { date: "22年12月", name: "GoGoX Holdings", amount: "$42M" },
  { date: "22年11月", name: "Klook Travel", amount: "$210M" },
  { date: "22年10月", name: "Lalamove HK", amount: "$150M" },
  { date: "22年09月", name: "TNG FinTech", amount: "$65M" },
];
